import { useEffect, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import i18n from './config'
import { getLanguageFromSearch } from './languages'

// Includes router navigation and browser back/forward without reloading the app.
export const LanguageSync = ({ children }: { children: ReactNode }) => {
  const { search } = useLocation()

  // Descendants subscribe to i18next before this parent effect notifies them.
  useEffect(() => {
    const language = getLanguageFromSearch(search)
    if (i18n.language !== language) {
      void i18n.changeLanguage(language)
    }
  }, [search])

  return <>{children}</>
}
